import React from "react";

import { FeaturedResourceBlock, FeaturedResourceCardBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonTextPrimary, LongButton } from "../../Clickables";
import { H } from "../../Headings";
import { Svg } from "../../Svg";
import { getThemeClass } from "../../ThemedModule";
import { STYLE } from "../constants";

import styles from "./Card.module.scss";

interface CardProps {
    card: FeaturedResourceCardBlock;
    style: FeaturedResourceBlock["style"];
    theme: FeaturedResourceBlock["module_theme"];
}

export const Card = ({ card, style, theme }: CardProps) => (
    <article
        className={concatClassNames([
            styles.card,
            style === STYLE.OPEN ? styles.open : getThemeClass(theme),
            !card.image ? styles.noImage : undefined,
        ])}
    >
        {card.image && (
            <div className={styles.imageWrapper}>
                <ImageChooserBlock value={card.image} attrs={{}} />
            </div>
        )}
        <div className={styles.content}>
            <H className={styles.headline}>{card.headline}</H>
            {card.body && (
                <p
                    className={concatClassNames([
                        styles.body,
                        style === STYLE.CONTAINED
                            ? styles.bodyContained
                            : undefined,
                    ])}
                >
                    {card.body}
                </p>
            )}
            {card.cta?.url && (
                <div
                    className={concatClassNames([
                        styles.ctaWrapper,
                        style === STYLE.CONTAINED
                            ? styles.ctaWrapperContained
                            : undefined,
                    ])}
                >
                    {style === STYLE.CONTAINED ? (
                        <LongButton variant="secondary" simpleLink={card.cta} />
                    ) : (
                        <ButtonTextPrimary simpleLink={card.cta}>
                            {card.cta.display_name}
                            <Svg name="arrow" aria-hidden="true" />
                        </ButtonTextPrimary>
                    )}
                </div>
            )}
        </div>
    </article>
);
